/**
 * EmptyState - Centered empty state display
 * Shows an emoji, primary message, and optional sub-message.
 */

interface EmptyStateProps {
  emoji: string;
  message: string;
  subMessage?: string;
}

export function EmptyState({ emoji, message, subMessage }: EmptyStateProps) {
  return (
    <div className="text-center py-12 text-gray-400">
      <div className="text-6xl mb-4">{emoji}</div>
      <p>{message}</p>
      {subMessage && (
        <p className="text-sm text-gray-500 mt-2">{subMessage}</p>
      )}
    </div>
  );
}
